import { render, staticRenderFns } from "./HSCodeCreate.vue?vue&type=template&id=77d8393e&scoped=true"
import script from "./HSCodeCreate.vue?vue&type=script&lang=js"
export * from "./HSCodeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d8393e",
  null
  
)

export default component.exports